module.exports = __webpack_public_path__ + "ab034e7fe08a23d5c4387fd8e4e13864.png";